export const SUPPORTED = [
  "uz",
  "ru",
  "en",
  "tr",
  "tg",
  "zh",
  "kk",
  "ky",
] as const;

export type SupportedLang = (typeof SUPPORTED)[number];

export const FALLBACK: SupportedLang = "uz";

// Legacy codes already sent by integrated host apps, plus codes a host is likely
// to guess. Everything funnels through normalizeLang, so accepting extras is free.
const ALIASES: Record<string, SupportedLang> = {
  tj: "tg",
  cn: "zh",
  kz: "kk",
  kg: "ky",
  uzb: "uz",
  rus: "ru",
  eng: "en",
  tur: "tr",
  tgk: "tg",
  kaz: "kk",
  kir: "ky",
  zho: "zh",
  chi: "zh",
};

const isSupported = (value: string): value is SupportedLang =>
  (SUPPORTED as readonly string[]).includes(value);

/**
 * The single gate every language value passes through, whatever its source.
 * Returns null — not the fallback — so callers can tell "not specified" from
 * "specified but unusable" and move on to the next source.
 */
export function normalizeLang(input: unknown): SupportedLang | null {
  if (typeof input !== "string") return null;

  // 'zh_Hans_CN' and 'ru-RU' both reduce to their primary subtag.
  const base = input.trim().toLowerCase().split(/[-_]/)[0];
  if (!base) return null;

  if (isSupported(base)) return base;

  return ALIASES[base] ?? null;
}
